/**
 * When a HUB video meeting's link is usable (PLAN-085 §1.3, §1.4).
 *
 * Shared by `web/` and `worker/` on purpose: the calendar's Join button and
 * the server's `meetings.join` must agree on the answer, or clicking an
 * invite link two days early starts the meeting — the room goes live, the
 * idle alarm runs, and ten minutes later it ends itself (REVIEW-1 #1).
 */

/** The room opens ten minutes before the scheduled start. */
export const JOIN_LEAD_MS = 10 * 60_000

/**
 * A live room is always joinable, an ended one never, and a scheduled one
 * from {@link JOIN_LEAD_MS} before its start. A meeting with no start time
 * (or an unparseable one) is treated as joinable rather than unreachable.
 */
export function canJoinNow(
  startAt: string | null,
  roomStatus: string | null,
  now = Date.now()
): boolean {
  if (roomStatus === 'live') return true
  if (roomStatus === 'ended') return false
  if (!startAt) return true
  const startMs = Date.parse(startAt)
  return Number.isNaN(startMs) ? true : now >= startMs - JOIN_LEAD_MS
}

/**
 * When the room *will* open, for the waiting screen's countdown — null when
 * it is open already (or has no start time to count down to).
 */
export function joinOpensAt(startAt: string | null, roomStatus: string | null): string | null {
  if (roomStatus !== 'scheduled' || !startAt) return null
  const startMs = Date.parse(startAt)
  if (Number.isNaN(startMs)) return null
  return new Date(startMs - JOIN_LEAD_MS).toISOString()
}
